import { Stack } from "@mui/material";
import { isSameDay } from "date-fns";

import { GqlFieldworkerAvailabilityStatus } from "~/__generated__";
import { theme } from "~/config/theme";
import { parseStringToDate } from "~/modules/app/util/dateHelpers";

const FIELDWORKER_AVAILABILITY_STATUS_TO_COLOR_MAP: Record<GqlFieldworkerAvailabilityStatus, string> = {
    [GqlFieldworkerAvailabilityStatus.Available]: theme.palette.primary.main,
    [GqlFieldworkerAvailabilityStatus.Scheduled]: theme.palette.secondary.main,
    [GqlFieldworkerAvailabilityStatus.Unavailable]: theme.palette.background.default,
};

export type FieldworkerAvailabilityByDate = {
    date: string;
    availabilities: {
        status: GqlFieldworkerAvailabilityStatus;
        name: string;
    }[];
}[];

type FieldworkerAvailabilityDotsProps = {
    availabilityByDate: FieldworkerAvailabilityByDate;
    selectedDate: string;
};

export function FieldworkerAvailabilityDots({ availabilityByDate, selectedDate }: FieldworkerAvailabilityDotsProps) {
    return (
        <Stack direction="row" columnGap={0.5}>
            {availabilityByDate.map(day => (
                <Stack key={day.date} rowGap={0.5}>
                    {day.availabilities.map(availability => (
                        <FieldworkerAvailabilityDot
                            key={availability.name}
                            status={availability.status}
                            isSelectedDate={isSameDay(parseStringToDate(selectedDate), parseStringToDate(day.date))}
                        />
                    ))}
                </Stack>
            ))}
        </Stack>
    );
}

function FieldworkerAvailabilityDot({
    status,
    isSelectedDate,
}: {
    status: GqlFieldworkerAvailabilityStatus;
    isSelectedDate: boolean;
}) {
    return (
        <svg
            width={10}
            height={10}
            viewBox="0 0 10 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{
                borderRadius: "50%",
                border: isSelectedDate ? `1px solid orange` : "none",
            }}
        >
            <title>{`Fieldworker availability ${status}`}</title>
            <circle cx="5" cy="5" r="5" fill={FIELDWORKER_AVAILABILITY_STATUS_TO_COLOR_MAP[status]} />
        </svg>
    );
}
